<template>
    <div class="spo-card rounded bordered pa-3">
        <div class="text-h6 font-weight-bold mb-3">Nouveau créneau</div>
        <v-form ref="formCreneau" v-model="formValid">
            <v-row>
                <v-col cols="12">
                    <label class="field_label">Course <span class="text-red">*</span></label>
                    <v-select v-model="form.id_course" :items="coursesOptions" item-title="text" item-value="value"
                        density="compact" hide-details :rules="[rules.requiredCourse]"></v-select>
                </v-col>
                <v-col cols="12">
                    <label class="field_label">Nom du créneau <span class="text-red">*</span></label>
                    <v-text-field v-model="form.nom" density="compact" hide-details
                        :rules="[$formRules.required]"></v-text-field>
                </v-col>
                <v-col cols="12">
                    <label class="field_label">Capacité <span class="text-red">*</span></label>
                    <v-text-field v-model.number="form.capacity" type="number" min="0" density="compact" hide-details
                        :rules="[rules.capacity]"></v-text-field>
                </v-col>
            </v-row>
            <div class="d-flex justify-end mt-2">
                <SportipsButton action-button icon="mdi-plus" :loading="submitting" @onClick="submit">Créer le
                    créneau</SportipsButton>
            </div>
        </v-form>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service";

export default {
    data() {
        return {
            formValid: false,
            submitting: false,
            courses: [],
            form: {
                id_course: null,
                nom: "",
                capacity: null,
            },
            rules: {
                requiredCourse: (v) => (v !== null && v !== undefined && v !== "") || "Choisissez une course.",
                capacity: (v) => {
                    const n = Number(v);
                    if (v === "" || v === null || Number.isNaN(n)) return "Indiquez une capacité.";
                    if (n < 0) return "La capacité doit être positive ou zéro.";
                    return true;
                },
            },
        };
    },
    computed: {
        ...mapStores(useMainStore),
        coursesOptions() {
            if (!this.courses.length) return [];
            return this.courses.map((course) => ({ text: course.nom, value: course.id }));
        },
    },
    methods: {
        resetForm() {
            this.form = {
                id_course: this.courses.length ? this.courses[0].id : null,
                nom: "",
                capacity: null,
            };
            this.$nextTick(() => this.$refs.formCreneau?.resetValidation?.());
        },
        async loadCourses() {
            if (!this.mainStore.module?.id) return;
            const res = await AdminService.getCourses(this.mainStore.module.id);
            this.courses = Array.isArray(res) ? res : [];
            if (this.courses.length && (this.form.id_course === null || this.form.id_course === "")) {
                this.form.id_course = this.courses[0].id;
            }
        },
        async submit() {
            const response = await this.$refs.formCreneau.validate();
            if (!response.valid) return;
            this.submitting = true;
            const payload = {
                id_module: this.mainStore.module.id,
                id_course: this.form.id_course,
                nom: this.form.nom.trim(),
                capacity: Number(this.form.capacity),
                is_open: 1,
            };
            const res = await AdminService.postCreneauRetraitDossard(payload);
            this.submitting = false;
            if (res === false || res?.error) {
                this.mainStore.notification.send(
                    typeof res?.error === "string" ? res.error : "Impossible de créer le créneau.",
                    "error"
                );
                return;
            }
            this.mainStore.notification.send("Créneau créé.", "success");
            this.resetForm();
            this.$emit("created");
        },
    },
    async mounted() {
        await this.loadCourses();
    },
};
</script>

<style lang="scss" scoped></style>
